import request from '@/utils/request'


/**
 * 账户充值页面
 */
export function accountIndex(data) {
  return request({
    url: '/index/account/accountIndex',
    method: 'post',
    data
  })
}

/**
 * 账户余额信息
 */
export function accountInfo(data) {
  return request({
    url: '/index/account/accountInfo',
    method: 'post',
    data
  })
}

/**
 * 充值请求信息
 */
export function changeAlipayQrcode(data) {
  return request({
    url: '/index/account/changeAlipayQrcode',
    method: 'post',
    data
  })
}
/*
 * 账号充值查询
 */
export function getAlipayQuery(data) {
  return request({
    url: '/index/account/getAlipayTradeResult',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/account.js